import config from "../config";

const api_url = config.api_url;
const community_url = config.community_url;
const defaults = config.defaults;

const requestOptions = (type = 'POST') => {
    return {
        method: type,
        headers: {
            "Content-Type": "application/json"
        }
    }
}

const getPayerNames = () => {
    let options = {
        ...requestOptions('GET')
    }
    return fetch(`${api_url}/payernames?agency_guid=${defaults.agency_guid}&token=${sessionStorage.getItem('token')}`, options)
        .then(response => response.json());
}

const createPatient = (patient) => {
    let body = {
        ...patient,
        ...defaults,
        token: sessionStorage.getItem('token')
    }
    let options = {
        ...requestOptions()
    }
    options['body'] = JSON.stringify(body);
    return fetch(`${api_url}/ssupatient`, options)
        .then(response => response.json());
}

const createCommunityUser = (user) => {
    let options = {
        ...requestOptions()
    }
    let body = {
      Alias: user.alias,
      Profile_Image: '',
      Role: 1,
      Achess_Credentials: [{
        DB_Name: defaults.agency_guid,
        ACHESS_User_ID: user.user_id,
        ACHESS_GUID: user.user_guid
      }],
      SSO_ID: user.sso_id,
      IsChessEmployee: false,
      FCM_ID: "fgQEfi-DwBY:APA91bGFTimYTpIQjklNqy2wD2l9j9GUKvI58cBZa4CCEYcStGgZNW8ZR5-ueoV1YENSSE6gcGXVELeG-enTxDk-dLS-ZoWfp7smjMixL_5nIBGfoDwuY1rY5BH2tbXJfKj2bxUmujTy",
      Notification_Settings: {
        ChessPosts: true,
        FollowedTopics: true,
        CommentReplies: true,
        AllNewTopics: false
      },
      Communities: [process.env.VUE_APP_DEFAULT_COMMUNITY_ID],
      token: sessionStorage.getItem('token')
    }
    options['body'] = JSON.stringify(body);
    options.headers['ssu_token'] = sessionStorage.getItem('token');
    return fetch(`${community_url}/user/ssu`, options)
        .then(response => response.json());
}

const sendOnboardEmail = (patient, email) => {
    let body = {
        agency_guid: defaults.agency_guid,
        patient_guid: patient.user_guid,
        email: email,
        temp_pass: patient.temp_pass,
        token: sessionStorage.getItem('token')
    }
    let options = {
        ...requestOptions()
    }
    options['body'] = JSON.stringify(body);
    return fetch(`${api_url}/sendonboardemail`, options)
        .then(response => response.json());
}

export {
    getPayerNames,
    createPatient,
    createCommunityUser,
    sendOnboardEmail
}